import {useIsMobile, useIsBusinessDisabled} from 'hooks';

import Page from 'components/Page';
import PageTitle from 'components/Page/PageTitle';
import ClientsList from 'components/Staff/ClientsList';
import FloatingButtons, {LinkOption} from 'components/Common/FloatingButton';
import Locale from 'components/Common/Locale';
import Link from 'components/Common/Link';
import View from 'components/Common/View';

const Items = () => {
  const isBusinessDisabled = useIsBusinessDisabled();
  const isMobile = useIsMobile();

  return (
    <Page title="staff.clients.title" horizontalPadding>
      <PageTitle className="staff-title top-padding">
        <View className="expand">
          <Locale text="staff.clients.title" />
        </View>
        {!isMobile && !isBusinessDisabled && (
          <Link
            follows="new"
            className="btn dark-blue rounded header"
            label="staff.clients.new_client"
          />
        )}
      </PageTitle>
      {isMobile && !isBusinessDisabled && (
        <FloatingButtons>
          <LinkOption icon="plus" follows="new" />
        </FloatingButtons>
      )}
      <ClientsList />
    </Page>
  );
};

export default Items;
